/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  This file is used for controlling the global states of the components,
  you can customize the states for the different components here.
*/

import { createContext, useContext, useState, useMemo, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import localforage from "localforage";
import { useAppServices } from "../hook/services";
import ThemedLoader from "../components/ThemedLoader";

// Material Dashboard 2 React main context
const KnowledgebaseCustomizationContext = createContext();

// Setting custom name for the context which is visible on react dev tools
KnowledgebaseCustomizationContext.displayName ="KnowledgebaseCustomizationContext";

  const intialValues = {
  bgColor: "#6c757d",
  textColor: "#ffffff",
  companyName: "",
  logo: null,
  domain: "",
  customMenuLinkTitle: "",
  customMenuLinkLocations: [],
  customMenuLinkId: null,
  allowMultipleLanguages: false,
  allowLanguages: [],
  languageId: null,
};

function KnowledgebaseCustomizationProvider({ children }) {
  const AppService = useAppServices();
  const [languages, setLanguages] = useState([]);
  const [KnowledgebaseCustomization, setKnowledgebaseCustomization] = useState(
    {}
  );
  const [loader, setLoader] = useState(true);
  const pathname = window.location.pathname;
  const companyId = pathname.split("/")[1];
  const Update = (updates) => {
    const data = { ...KnowledgebaseCustomization, ...updates };
    setKnowledgebaseCustomization(data);
  };

  const clear = () => setKnowledgebaseCustomization({});

  const getKnowledgebaseCustomization = async () => {
    setLoader(true);
    try {
      const { response } = await AppService.knowledgebase_customization.filter({
        query: `companyId=${companyId}`,
      });

      if (response?.data) {
        const data = response.data;
        // const mappedAllowLanguages = data.allowLanguages
        //   ? data.allowLanguages
        //       .map((id) => languages.find((lang) => lang.value === id))
        //       .filter(Boolean)
        //   : [];

        // const defaultLanguageOption = languages.find(
        //   (lang) => lang.value === data.languageId
        // );

        setKnowledgebaseCustomization({
          ...intialValues,
          ...data
        });
      } else {
        setKnowledgebaseCustomization(intialValues);
      }
    } catch (error) {
      setKnowledgebaseCustomization(intialValues);
    } finally {
      setLoader(false);
    }
  };

  const value = useMemo(
    () => [KnowledgebaseCustomization,languages, Update,getKnowledgebaseCustomization, clear],
    [KnowledgebaseCustomization,languages, Update,getKnowledgebaseCustomization, clear]
  );


  const getLanguages = async () => {
    try {
      const { response } = await AppService.knowledgebase_language.get();
      if (response) {
        const mappedLanguages = response.data.map((lang) => ({
          value: lang._id,
          label: lang.name,
        }));
        setLanguages(mappedLanguages);
      } else {
        setLanguages([]);
      }
    } catch (error) {
      setLanguages([]);
    }
    // finally {
    //   setLoading(false);
    // }
  };

  const onLoad = () => {
    getLanguages();
    getKnowledgebaseCustomization();
  };

  useEffect(onLoad, []);

   if (loader) {
    return <ThemedLoader variant="page" size="lg" label="Loading knowledgebase" />;
  }

  return (
    <KnowledgebaseCustomizationContext.Provider value={value}>
      {children}
    </KnowledgebaseCustomizationContext.Provider>
  );
}

// Material Dashboard 2 React custom hook for using context
function useKnowledgebaseCustomizationInfo() {
  return useContext(KnowledgebaseCustomizationContext) || [];
}

// Typechecking props for the MaterialUIControllerProvider
KnowledgebaseCustomizationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export {
  KnowledgebaseCustomizationProvider,
  useKnowledgebaseCustomizationInfo,
};
